import { Link } from "react-router-dom";
import { MapPin, Mail, Instagram } from "lucide-react";

export function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-neutral-300 mt-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <p className="font-serif text-3xl text-white tracking-tight">The House of Ego</p>
          <p className="mt-1 text-[11px] uppercase tracking-[0.25em] text-neutral-500">
            / haʊs ʌv ˈiː.ɡoʊ / · noun, proper
          </p>
          <p className="mt-4 text-sm leading-relaxed text-neutral-400 max-w-xs">
            The transcendence of ego through creative expression. A creative sanctuary bridging art,
            healing, and storytelling through curated community experience.
          </p>
        </div>
        <nav aria-label="Footer" className="grid grid-cols-2 gap-2 text-sm">
          {[
            ["/", "Home"],
            ["/curatorial", "Curatorial Work"],
            ["/gallery", "Artwork"],
            ["/about", "About Seyoun"],
            ["/contact", "Contact"],
            ["/philosophy", "Philosophy"],
          ].map(([to, label]) => (
            <Link
              key={to}
              to={to}
              data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-").replace(/&/g, "")}`}
              className="py-1.5 link-underline w-fit text-neutral-400 hover:text-white transition-colors"
            >
              {label}
            </Link>
          ))}
        </nav>
        <div className="text-sm space-y-3">
          <p className="text-[11px] uppercase tracking-[0.25em] text-neutral-500">Connect</p>
          <p className="flex items-center gap-2">
            <Mail size={15} className="text-flame" />
            <a
              href="mailto:seyountaylor60@gmail.com"
              data-testid="footer-email-link"
              className="link-underline hover:text-white transition-colors"
            >
              seyountaylor60@gmail.com
            </a>
          </p>
          <p className="flex items-center gap-2">
            <Instagram size={15} className="text-flame" />
            <a
              href="https://instagram.com/seyountheeartist"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="link-underline hover:text-white transition-colors"
            >
              @seyountheeartist
            </a>
          </p>
          <p className="flex items-center gap-2">
            <MapPin size={15} className="text-flame" />
            <span>Dallas–Fort Worth, Texas · Serving collectors everywhere</span>
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} The House of Ego · Seyoun Taylor. All artwork rights reserved.</p>
          <p>Art as mirror, not spectacle.</p>
        </div>
      </div>
    </footer>
  );
}
